<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="onSubmit">
		<smart-input
			v-model="form.name"
			:error="inputErrors.name"
			name="name"
			label="שם משחק"
		/>
		<organizations-select
			v-model="form.organizations"
			:multiple="true"
			hint="אלו מרכזים יורשו לייצר משחקים אלו?"
		/>
		<smart-input
			v-model="form.min_questions"
			type="number"
			:error="inputErrors.min_questions"
			label="מספר שאלות מינימלי"
			:min="0"
		/>

		<v-checkbox
			v-for="option in options"
			:key="option.id"
			v-model="form.allowed_questions"
			:label="option.text"
			:value="option.value"
		/>

		<smart-input
			v-model="form.active"
			type="checkbox"
			name="active"
			:error="inputErrors.active"
			label="פעיל"
		/>

		<media-gallery-preview
			v-model="form.media_id"
			:image-url="type.logo"
		/>
		<v-textarea
			v-model="form.description"
			name="description"
			:error="inputErrors.description"
			label="תיאור המשחק"
		/>
		<input
			type="file"
			name="json"
			:error="inputErrors.json_path"
			label="json_path"
		>
		<div class="form-group mt-2">
			<v-btn
				:loading="inProgress"
				type="submit"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
		</smart-input>
	</form>
</template>

<script>
import TypeModule from "src/store/modules/Type.module";
import FormView from "src/mixins/FormView";
import OrganizationsSelect from "dev/view/organizations/OrganizationsSelect";
import MediaGalleryPreview from "../../packages/gallery/MediaGalleryPreview";
import QuestionType from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";

export default {
	name: "TypeForm",
	components: { OrganizationsSelect, MediaGalleryPreview },
	props: [],
	data () {
		return {
			form: {
				name: null,
				min_questions: 0,
				active: 1,
				logo: "",
				organizations: [],
				allowed_questions: [],
				description: "",
			},
		};
	},
	mixins: [new FormView(TypeModule, "type", true)],
	computed: {
		isNew () {
			return !!this.type.id;
		},
		options () {
			return QuestionType.getAsOption();
		},
	},
	created () {
		if (this.form.id) {
			this.fillAllowedQuestionsWithTypeData();
		}
	},

	methods: {
		getData (e) {
			const formData = new FormData(e.target);
			if (this.form.id) {
				formData.id = this.form.id;
			}
			Object.keys(this.form).forEach((key) => {
				const value = this.form[key];
				if (typeof value === "boolean") {
					formData.append(key, +value);
				} else if (Array.isArray(value)) {
					value.forEach((val) => {
						formData.append(key + "[]", val);
					});
				} else {
					formData.append(key, value);
				}
			});

			return formData;
		},
		selectImg (val) {
			console.log(val, "sadsa");
		},
		fillAllowedQuestionsWithTypeData () {
			this.form.allowed_questions = this.form.question_type.map(
				(questionType) => {
					return questionType.question_type;
				}
			);
		},
	},
};
</script>

<style>
</style>
